<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-info">
          <h3>About Us</h3>
          <div class="footer-text">
            אולפן הקלטות ביסעור
            <br />
            <a href="tel:+972547886141" class="phone-link">
              <i class="fa-solid fa-phone"></i> 054-7886141
            </a>
            <br />
            <a href="mailto:uazulay@gmail.com?subject=About Yasur studio..." class="email-link">
              <i class="fa-solid fa-envelope"></i> uazulay@gmail.com
            </a>
          </div>
        </div>
        
        <div class="social-links">
          <a href="https://www.facebook.com/udi.azulay.16" class="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-facebook-f"></i>
          </a>
          <a href="https://www.youtube.com/playlist?list=PLXHSCk9pLf1F6zyrBmEoliLJ09kf4S5TP" class="social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-youtube"></i>
          </a>        
          <a href="https://www.instagram.com/udi_azulay/" class="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/in/udi-azulay-7770b65/" class="social-icon" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-linkedin-in"></i>
          </a>
        </div>
      </div>
      
      <div class="copyright">
        <p>Made with <i class="fa-regular fa-heart"></i> By Udi Azulay</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>


<style scoped>
.site-footer {
  background-color: var(--dark-bg);
  color: var(--light-text);
  padding: 3rem 0 1rem;
  margin-top: 2rem;
}

.footer-container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.footer-info {
  text-align: center;
}

.footer-info h3 {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.footer-info h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: var(--accent-color);
}

.footer-text {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-top: 1.5rem;
}

.phone-link, .email-link {
  color: var(--light-text);
  text-decoration: none;
  transition: color 0.3s ease;
  display: inline-block;
  margin: 5px 0;
}

.phone-link:hover, .email-link:hover {
  color: var(--accent-color);
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 1.5rem 0;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: var(--light-text);
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: var(--accent-color);
  color: var(--dark-bg);
  transform: translateY(-5px);
}

.fa-regular, .fa-solid, .fa-brands {
  font-size: 1.2rem;
}

.fa-heart {
  color: #f44336;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.copyright {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright p {
  font-size: 0.9rem;
  opacity: 0.8;
}

@media (min-width: 768px) {
  .footer-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
  
  .footer-info {
    text-align: left;
    flex: 1;
  }
  
  .footer-info h3::after {
    left: 0;
    transform: none;
  }
  
  .social-links {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .site-footer {
    padding: 2rem 0 1rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
  }
  
  .footer-text {
    font-size: 1rem;
  }
}
</style>